export default "__VITE_ASSET__CkzMfuj9__"